<template>
  <div class="main-content visimisi">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Visi Dan Misi</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-content">
      <div class="container about-detail-container">
        <div class="section-content">
          <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
          <div v-else v-html="content"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  data() {
    return {
      show_loading: true,
    };
  },
  mounted() {
    this.getVisiMisi();
  },
  methods: {
    getVisiMisi() {
      api
        .post(api.route.get.page, { slug: "visi-misi" })
        .then((res) => {
          let status = res.status;
          if (status) {
            this.show_loading = false;
            this.content = res.data.content;
          }
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/VisiMisi.vue